import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit,ChangeDetectorRef } from '@angular/core';
import {FormBuilder, FormGroup,FormArray, Validators} from "@angular/forms";
import {Router, ActivatedRoute} from "@angular/router";
import { Da7420ServiceService } from '../../../../../Service/da7420/da7420-service.service';
import { from } from 'rxjs';
import { MatDialog ,MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
//import { LayoutUtilsService } from 'src/app/core/_base/crud';
import { LayoutUtilsService, MessageType } from '../../../../../core/_base/crud';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {DatePipe} from '@angular/common';
import { Ba1300Class } from '../../../../../Class/ba1300/ba1300-class';
import { EmployeeListClass } from '../../../../../Class/common/employee-list/employee-list-class';
import { EmployeeListComponent } from '../../../../pages/Hrms/common/employee-list/employee-list.component';
import { Alert } from 'selenium-webdriver';
import { Da6110Class } from '../../../../../Class/da6110/da6110-class';
import { Adm0006Class } from '../../../../../Class/ADM0006/adm0006-class';
import { WIDGET0004Class } from '../../../../../Class/WIDGET0004/widget0004-class';
import { WIDGET0005Class } from '../../../../../Class/WIDGET0005/widget0005-class';
import { WIDGET0004ServiceService } from '../../../../../Service/WIDGET0004/widget0004-service.service';
import { environment } from '../../../../../../environments/environment';
import { FileAttachmentComponent } from '../../../../pages/Hrms/common/file-attachment/file-attachment.component';
import { FileAttachmentInput } from '../../../../../Class/common/file-attachment/file-attachment-input';
import { Widget0004Component } from '../widget0004/widget0004.component';
@Component({
  selector: 'kt-widget-details',
  templateUrl: './widget-details.component.html',
  styleUrls: ['./widget-details.component.scss']
})
export class WidgetDetailsComponent   implements OnInit,AfterViewInit {


  cdialogResult:any;
  objEmployeeListClass = new EmployeeListClass();
  Form:FormGroup;
  closeResult: string;
  MandatoryStatus: string;
  EmployeeList:Ba1300Class[];
  PayslipList:Adm0006Class[];
  CalenderList:any[];
  PaySlipList:any[];
  FkPerdIdList:any[];
  ValSelect:any;


  lblPageTitle: string = "";
  lblBack: string;
  lblClear: string;
  lblDelete: string;
  lblSave: string;
  lblSave_Exit: string;
  lblSave_Duplicate: string;
  lblSave_Continue: string;
  lblBack_to_Fin_Tool: string;
  lblClear_Changes_Tool: string;
  lblDelete_Selected_Entry_Tool: string;
  lblSave_Exit_Tool: string;
  lblDelMaster_Heading: string;
  lblDelMaster_Message: string;
  lblDelMaster_Progress_Message: string;
  lblDelMaster_Confirmation: string;
  lblDelMaster_Cancel: string;
  lblDelMasterDelete: string;
  lblConfirmTran: string;
  lblUserNam: string;
  lblUserLgnPwd: string;
  lblUserTrnPwd: string;
  lblFkFieldIdUserGroup: string;
  lblFkFieldIdUserType: string;
  lblFkEmpId:string;
  lblExternalUserName:string;
  lblActive:string;
  lblRemarks:string;
  lblValidUpTo:string;
  lblPortalUser:string;
  lblFkRoleId:string;
  lblFkCompId:string;
  lblConfirm:string;
  CtrlNames:any[];
  lblSelect:string;
  lblAdd:string;
  lblDuplication: string;
  lblMandatory: string;
  lblSystemError: string;

  // lblReferenceNo: string  
  lblTitle: string;
  lblMessages: string;
  lblTillDate:string;
  lblSendViaEmail: string;
  lblAttachment: string;
  lblSelectEmployees: string;
  lblSelectEmployeesToolTip: string;
  tblAnnouncementDetailsArray :Array<any>=[];
  objFileAttachmentInput = new FileAttachmentInput();
  Errors:any[];
  count:number;
  private fieldArray: Array<any> = [];
  fieldArrayCount:any[];
  objAnnouncementDatails = new WIDGET0004Class();
  WIDGET0005List: Array<WIDGET0005Class> = [];
  objDa7420Service: any;
 dialogRef1:any;
  constructor(public dialogRef: MatDialogRef<WidgetDetailsComponent>,public dialog: MatDialog,private formBuilder: FormBuilder,private router: Router,private route: ActivatedRoute,
   private objWIDGET0004ervice:WIDGET0004ServiceService,private layoutUtilsService: LayoutUtilsService,private modalService: NgbModal, private changeDetectorRef: ChangeDetectorRef ) {

  }
	ngOnInit() {
  
    this.Form = this.formBuilder.group({
   
  

    });

    this.objEmployeeListClass.EmployeeList = [];
    this.CalenderList = []; 
    this.FkPerdIdList = [];   
    this.PaySlipList=[];
    this.Errors=[];
    this.lblSelectEmployees = "Select Employees";
    this.lblSelectEmployeesToolTip = "Employees Selected";
    document.getElementById('divSelecedEmployee').hidden = true;

    



  }

  ngAfterViewInit()
  {
 
  this.route.queryParams.subscribe(params => {
    this.LoadList()
   

    })
  }
  Close()
  {
    
    this.dialogRef.close(`${""}`);
  }
  AnnouncementDatails(field){

  this.objAnnouncementDatails.AnnouncementId=field;

	this.dialogRef1=this.dialog.open(Widget0004Component, {
    width: '600px',height:'300px',
		data:this.objAnnouncementDatails
	  }); 
  
    // var url = '/hrms/widget0004-detail';
    
  
    // this.router.navigate([url], { queryParams: {'AnnouncementId': field, } });   
   
   // this.dialogRef.close(`${""}`);
    }

  LoadList()
  {

    this.objWIDGET0004ervice.GetCountAnnouncement().subscribe(list=>{ 
      this.fieldArrayCount=list;		

    // this.objWIDGET0004ervice.GetCountAnnouncement().subscribe(data=>{  
   
    //   this.tblAnnouncementDetailsArray = data.WIDGET0004List ;    
      
      this.changeDetectorRef.detectChanges();
      })
  }





 




  
  getComponentTitle() 
  {

		let result = this.lblPageTitle;
		return result;
  }

  }









  



